import React from 'react'
// import { connect } from 'react-redux'

import classNames from 'classnames'

// import dataManager from 'pages/main/data/DataManager'
// import { getSearchParams } from 'utils'

import SendHelper from 'pages/main/components/SendHelper'
import EmailForm from 'pages/main/components/EmailForm'

import styles from './style.module.scss'

// const mapStateToProps = ({ dispatch, user }) => ({
//   dispatch,
//   user,
// })

interface EmailEditorProps {
  helper?: any
  myWin?: any
  isReady?: boolean
  onSetIFrame?: any
  // popup(EmailEditorWindow) 소비자용 옵션 콜백. 지정 시 내부 close() 대신 이 콜백을 호출한다.
  // onSended 는 EmailForm 의 send 결과 { mailData, prevDraft } 를 그대로 전달받는다.
  onSended?: (res?: any) => void
  onCanceled?: () => void
}

interface EmailEditorState {
  sendHelper: any
  startLoading: boolean
}

// @connect(mapStateToProps)
class EmailEditorDef extends React.Component<EmailEditorProps, EmailEditorState> {
  state: EmailEditorState = {
    sendHelper: null,
    startLoading: false,
  }

  isSended = false
  intervalTimer: any = null

  componentDidMount() {
    if (window.parent != null) {
      const { helper } = this.props

      this.setState({
        sendHelper: helper,
      })
    } else {
      const sendHelper = new SendHelper()

      this.setState({
        sendHelper,
      })
    }

    this.intervalTimer = setTimeout(() => {
      this.setState({
        startLoading: true,
      })
    }, 2000)
  }

  // componentDidUpdate(prevProps) {
  // }

  componentWillUnmount() {
    if (this.intervalTimer != null) {
      clearInterval(this.intervalTimer)
    }
  }

  close = () => {
    if (window.opener != null) {
      window.close()
    } else if (window.parent != null && window.parent.opener != null) {
      window.parent.close()
    }
  }

  onSended = (res?: any) => {
    const { onSended } = this.props
    if (onSended != null) {
      onSended(res)
    } else {
      this.close()
    }
  }

  onCanceled = () => {
    const { onCanceled } = this.props
    if (onCanceled != null) {
      onCanceled()
    } else {
      this.close()
    }
  }

  needSave = () => {
    const { sendHelper } = this.state

    // popup 의 beforeunload 가 sendHelper 설정 전에 발화할 수 있으므로 null 가드.
    if (sendHelper == null) {
      return false
    }

    if (sendHelper.isSendCalled === true || sendHelper.isDeleteCalled === true) {
      return false
    } else if (sendHelper.formAPIs != null) {
      if (sendHelper.formAPIs.isModified() !== true) {
        return false
      }

      // const { subject, htmlText } = sendHelper.formAPIs.getEmailValues()

      // if (subject != null || (htmlText != null && htmlText.trim().length > 0)) {

      // 닫으려고 시도한 경우, 일단 draft에 저장을 시도하고, 저장이 성공하면 최종 상태를 저장.
      sendHelper.formAPIs.callSave()

      return true
      // }
    }

    return false
  }

  render() {
    const { sendHelper, startLoading } = this.state
    const { myWin, isReady, onSetIFrame } = this.props

    let editorElem = null
    if (sendHelper != null && isReady === true && startLoading === true) {
      editorElem = (
        <EmailForm
          myWin={myWin}
          helper={sendHelper}
          onSended={this.onSended}
          onCanceled={this.onCanceled}
          onSetIFrame={onSetIFrame}
        />
      )
    }

    return <div className={classNames(styles.EmailEditor)}>{editorElem}</div>
  }
}

const EmailEditor = EmailEditorDef

export default EmailEditor
